import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/system';

export const StyledSummaryContainer = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '0.5rem',
});

export const StyledStatusLine = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  color: theme.palette.text.secondary,
}));
